import { useMutation, useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { EvseService } from "./evse.service";

export const useEvse = (params: TParams) => {
  return useQuery(
    ["list_evbs", params],
    async () => {
      const { data } = await EvseService.getAll(params);
      return data;
    },
    { keepPreviousData: true },
  );
};

export const useDetailEvse = (id?: string) => {
  return useQuery(
    [id],
    async () => {
      const { data } = await EvseService.getDetail(id!);
      return data;
    },
    {
      enabled: id ? true : false,
    },
  );
};

export const useTopUtilizationRatingEvse = (params: TParams) =>
  useQuery({
    queryKey: ["top-utilization-rating-evse"],
    queryFn: async () => {
      try {
        const { data } = await EvseService.topUtilizationRating(params);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useListUserEvse = (params?: Object) =>
  useQuery({
    queryKey: ["list_users_evse", params],
    queryFn: async () => {
      try {
        const { data } = await EvseService.listUser(params);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useUpdateEvse = () =>
  useMutation({
    mutationFn: async ({ id, dto }: { id: string; dto: Object }) => {
      try {
        const { data } = await EvseService.update(id, dto);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useAddRestrictedUserEvse = () =>
  useMutation({
    mutationFn: async ({
      dto,
    }: {
      dto: { user_ids: string[]; evse_ids: string[] };
    }) => {
      try {
        const { data } = await EvseService.addRestrictedUser(dto);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useRemoveRestrictedUserEvse = () =>
  useMutation({
    mutationFn: async ({
      dto,
    }: {
      dto: { user_ids: string[]; evse_ids: string[] };
    }) => {
      try {
        const { data } = await EvseService.RemoveRestrictedUser(dto);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useUpdateRestrictedUserEvse = () =>
  useMutation({
    mutationFn: async (dto: { user_id: string; evse_ids: string[] }) => {
      try {
        const { data } = await EvseService.UpdateRestrictedUser(dto);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useOnOffSubscriptionPlansEvse = () =>
  useMutation({
    mutationFn: async (dto: {
      evse_id: string;
      subscription_price_enabled: boolean;
      enable_subscription_plans: string[];
    }) => {
      try {
        const { data } = await EvseService.OnOffSubscriptionPlans(dto);
        return data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });

export const useStaticEvse = (type: string) =>
  useQuery({
    queryKey: ["statistics", type],
    queryFn: async () => {
      const { data } = await EvseService.getStatic(type);
      return data;
    },
  });

export const useSyncEvse = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (evseId: string) => {
      const { data } = await EvseService.sync(evseId);
      return data;
    },
    onSuccess: (data) => {
      if (data?.ok) {
        toast.success("Sync successfully!");
        queryClient.invalidateQueries(["list_evbs"]);
      } else {
        toast.error(data?.msg || "Sync failed");
      }
    },
    onError: (err: any) => {
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Sync failed";
      toast.error(errorMessage);
    },
  });
};
